/**
 * @author xiaohuangmaoth
 * @description 在线课程完成情况
 * @Date 2021/03/02
 */
import React from "react";
import {connect} from "dva";
import {framework_tool} from "@/tool";
import {templateConfig, reduxTemplateCofig} from "./config";
import column from "./column";
import {mapStateToProps, handleExport} from "../../utils";

const {WizContainer, WizReduxTemplate} = framework_tool;


class OnlineCourseCompletionStatus extends WizContainer {
  componentName = "OnlineCourseCompletionStatus";

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: handleExport.bind(this, {title: '在线课程完成情况', column}),
      },
    });
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(
  mapStateToProps.bind(this, {
    nameSpace: "programReport",
    method: "getPageList",
  })
)(OnlineCourseCompletionStatus);
